'use client';

import reservation from 'public/static/icons/reservation.svg';
import './css/callToAction.css';
import Image from 'next/image';

interface ICallToAction {
  handleClick: () => void;
}

export const CallToAction = ({ handleClick }: ICallToAction) => {
  return (
    <div className="tour-cta__inner bg-gray-800">
      <div className="flex flex-col gap-3">
        <Image src={reservation} alt="reservation" />
        <div>
          <h3 className="text-xl font-rokkitt">Make a reservation</h3>
          <p className="text-gray-500 font-light">When would you want to go to this tour?</p>
        </div>
      </div>
      <button className="btn absolute lg:relative top-[calc(100%+1.5rem)] font-semibold" onClick={handleClick}>
        See available tours
      </button>
    </div>
  );
};
